export default {
  placeholder: 'Søg',
  cancel: 'Annuller',
};
